"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconMasterCard = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 131.39 86.9",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      opacity: "0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: "#fff",
        width: "131.39",
        height: "86.9"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      fill: "#ff5f00",
      x: "48.37",
      y: "15.14",
      width: "34.66",
      height: "56.61"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#eb001b",
      d: "M51.94,43.45a35.94,35.94,0,0,1,13.75-28.3,36,36,0,1,0,0,56.61A35.94,35.94,0,0,1,51.94,43.45Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#f79e1b",
      d: "M120.5,65.76V64.6H121v-.24h-1.19v.24h.47v1.16Zm2.31,0v-1.4h-.36l-.42,1-.42-1h-.36v1.4h.26V64.7l.39.91h.27l.39-.91v1.06Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#f79e1b",
      d: "M123.94,43.45a36,36,0,0,1-58.25,28.3,36,36,0,0,0,0-56.61,36,36,0,0,1,58.25,28.3Z"
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconMasterCard')(IconMasterCard);